// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconMinus.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconMinus = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 16" fill="currentColor" { ...props }>
    <rect x="16" y="7" width="2" height="16" rx="1" transform="rotate(90 16 7)" />
  </BaseIcon>
);

export default IconMinus;
